import React from 'react';

const InputPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/input',
			exact: true,
			component: React.lazy(() => import('./InputPage')),
		},
	],
};

export default InputPageConfig;
